<template>
  <v-layout wrap>
      <v-flex sm6 px-2>
        <v-text-field clearable hide-details v-model="filter.filterMission" :label="$t('Admin.Search')" append-icon="mdi-magnify"
        @click:clear="filter.filterMission = ''" />                
      </v-flex>            
      <v-flex sm6 px-2 >
        <v-select clearable hide-details :items="planModes" item-text="libelle" item-value="value" :label="$t('Simulation.PlanMode')"
            @click:clear="filter.filterTypePlanif = ''"
            v-model="filter.filterTypePlanif"
          ></v-select>
      </v-flex>
      <v-flex sm6 px-2 >
      <v-menu
        :close-on-content-click="false"
        v-model="showDateStart"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="310px"
        min-width="310px"
      >
        <v-text-field hide-details 
          clearable
          slot="activator"          
          v-model="formatedFilterDateStart"
          :label="$t('Simulation.FilterStartMission')"
          append-icon="mdi-calendar"
          readonly   
          @click:clear="filter.filterDateStart = ''"
        ></v-text-field>
        <v-date-picker v-model="filter.filterDateStart" no-title @input="showDateStart = false"></v-date-picker>
      </v-menu>      
    </v-flex>
    <v-flex sm6 px-2 >
      <v-menu
        :close-on-content-click="false"
        v-model="showDateEnd"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="310px"
        min-width="310px"
      >
        <v-text-field hide-details 
          slot="activator"
          clearable
          v-model="formatedFilterDateEnd"
          :label="$t('Simulation.FilterEndMission')"
          append-icon="mdi-calendar"
          readonly
          @click:clear="filter.filterDateEnd = ''"
        ></v-text-field>
        <v-date-picker v-model="filter.filterDateEnd" no-title @input="showDateEnd = false"></v-date-picker>
      </v-menu>
    </v-flex>
      <!-- <v-flex sm6 px-2 v-if="gliders.length > 1">
        <v-autocomplete :menu-props="{ closeOnClick: false, openOnClick: false }" hide-no-data browser-autocomplete="disable" dense small-chips deletable-chips hide-selected multiple v-model="adminGlideFilterIds" clearable clear-icon="mdi-close" item-text="libelle" item-value="id" :items="gliders" :label="$t('Admin.AdminMission.List.FilterGlider')"></v-autocomplete>
      </v-flex>
      <v-flex sm6 px-2 >
        <v-switch hide-details v-model="adminFilterOnGoing" :label="$t('Admin.AdminMission.List.FilterOngoing')"></v-switch>                
        <v-switch hide-details v-model="adminFilterSimulated" :label="$t('Admin.AdminMission.List.FilterSimule')"></v-switch>
      </v-flex> -->
  </v-layout>
</template>


<script lang="ts">
import { SimulationMode } from '@/enum/SimulationMode'
import { MissionGlobalType } from '@/enum/MissionGlobalType'
import Vue from 'vue'
import Component from 'vue-class-component'


@Component({
  name: 'PlanningFilter'
})
export default class PlanningFilter extends Vue {  

  created() {                
  }

  showDateStart = false
  showDateEnd = false

  get filter() {    
    //@ts-ignore
    return this.$store.myGetters.smartPlanningUiState
  }

  // BLF037 — seulement les types autorisés dans au moins une enseigne vue (RG-ACC-049).
  get planModes(){
    const known: MissionGlobalType[] = this.$store.myGetters.knownMissionGlobalTypes
    return [
      {libelle:this.$t('Simulation.Manual'),value:SimulationMode.simulator,typ:MissionGlobalType.SIMULATION},
      {libelle:this.$t('Simulation.Coverage'),value:SimulationMode.coverage,typ:MissionGlobalType.COVERAGE},
      {libelle:this.$t('Simulation.KeepFormation'),value:SimulationMode.formation,typ:MissionGlobalType.FORMATION}
    ].filter(mode => known.includes(mode.typ))
  }

    get formatedFilterDateStart () {
      return this.formatDate(this.filter.filterDateStart)        
    }

    get formatedFilterDateEnd(){
      return this.formatDate(this.filter.filterDateEnd)        
    }

    formatDate (date:string) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    }
    
}
</script>
